import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import WorkspaceDropdown from './WorkspaceDropdown'
import SidebarMenu from './SidebarMenu'
import SidebarMenuBottom from './SidebarMenuBottom'
import AccountPopup from '@SiteContainers/AccountPopup'

import {
  ISetCurrentWorkspacePayload,
} from '@SiteModules/Workspace/types'

import {
  openAccountPopup,
  closeAccountPopup,
} from '@SiteModules/Popup/actions'

import {
  setCurrentWorkspace,
} from '@SiteModules/Workspace/actions'

import {
  getCurrentAccountId,
  getCurrentAccountName,
  getCurrentAccountHasCurrentSubscription,
  getCurrentAccountAvatarUrl,
} from '@SiteModules/Account/selectors'

import {
  getHasExternalChannels,
} from '@SiteModules/ExternalChannel/selectors'

import {
  getCurrentWorkspaceName,
  getCurrentWorkspaceId,
  getWorkspaces,
} from '@SiteModules/Workspace/selectors'

import {
  getTotalCount as getTotalCountProjects,
} from '@SiteModules/Project/selectors'

import {
  getTotalCount as getTotalCountElements,
} from '@SiteModules/Element/selectors'

import {
  getTotalCount as getTotalCountSpeakerVoices,
} from '@SiteModules/SpeakerVoice/selectors'

import {
  getAccountPopupIsOpen,
} from '@SiteModules/Popup/selectors'

import './Sidebar.scss'

interface SidebarProps {
  pageName: string
}

const Sidebar: React.FC<SidebarProps> = props => {
  const dispatch = useDispatch()

  const hasExternalChannels = useSelector(getHasExternalChannels)
  const currentAccountName = useSelector(getCurrentAccountName)
  const currentAccountId = useSelector(getCurrentAccountId)
  const currentWorkspaceName = useSelector(getCurrentWorkspaceName)
  const currentWorkspaceId = useSelector(getCurrentWorkspaceId)
  const totalCountOfProjects = useSelector(getTotalCountProjects)
  const totalCountOfElements = useSelector(getTotalCountElements)
  const totalCountOfSpeakerVoices = useSelector(getTotalCountSpeakerVoices)
  const workspaces = useSelector(getWorkspaces)
  const accountPopupIsOpen = useSelector(getAccountPopupIsOpen)
  const currentAccountHasCurrentSubscription = useSelector(getCurrentAccountHasCurrentSubscription)
  const currentAccountAvatarUrl = useSelector(getCurrentAccountAvatarUrl)

  const hasWorkspaces = workspaces.length > 0

  const toggleAccountPopup = () => {
    if (accountPopupIsOpen) {
      dispatch(closeAccountPopup())
    } else {
      dispatch(openAccountPopup())
    }
  }

  const handleSetCurrentWorkspace = (payload: ISetCurrentWorkspacePayload) => {
    dispatch(setCurrentWorkspace(payload))
  }

  return (
    <div
      className="Sidebar"
      id="sidebar"
    >
      <div className="Sidebar__main">
        <div className="Sidebar__upper">
          <WorkspaceDropdown
            currentWorkspaceId={currentWorkspaceId}
            currentWorkspaceName={currentWorkspaceName}
            workspaces={workspaces}
            setCurrentWorkspace={handleSetCurrentWorkspace}
          />
          {hasWorkspaces && (
            <SidebarMenu
              pageName={props.pageName}
              hasExternalChannels={hasExternalChannels}
              totalCountOfProjects={totalCountOfProjects}
              totalCountOfElements={totalCountOfElements}
              totalCountOfSpeakerVoices={totalCountOfSpeakerVoices}
              currentAccountHasCurrentSubscription={currentAccountHasCurrentSubscription}
            />
          )}
        </div>
        <div className="Sidebar__lower">
          <SidebarMenuBottom
            currentAccountId={currentAccountId}
            currentAccountName={currentAccountName}
            currentAccountAvatarUrl={currentAccountAvatarUrl}
            toggleAccountPopup={toggleAccountPopup}
            accountPopupIsOpen={accountPopupIsOpen}
          />
          <AccountPopup accountPopupIsOpen={accountPopupIsOpen} />
        </div>
      </div>
    </div>
  )
}

export default Sidebar
